import { useMemo } from 'react';
import { alsHtml } from './als-html.js';
import stile from './anhang-bereich.module.css';

/**
 * "Seite" war mehrdeutig, gemeint ist die veroeffentlichte Produktseite (Rueckmeldung
 * 2026-10-14). Der Satz kommt aus dem n8n-Prompt; bis er dort angepasst ist, korrigiert ihn die
 * Anzeige. Andere Fassungen bleiben unberuehrt.
 */
export function anhangText(anhang: string): string {
  return anhang.replaceAll('gehört nicht auf die Seite.', 'gehört nicht auf die finale Website.');
}

/**
 * Der redaktionelle Anhang einer Produktseite (`editorial_analysis`, Spec 2026-10-12 §5.5), nur
 * zum Lesen. Er steht AUSSERHALB der Textflaeche: kein Block, kein Abschnitt, also weder Markieren
 * noch Bearbeiten, und er gehoert weder zum Entwurf noch zur Entscheidung. Gerendert ueber
 * dieselbe Allowlist wie der Text (`alsHtml`), denn er kommt ebenfalls aus einem Sprachmodell.
 */
export function AnhangBereich({ anhang }: { anhang: string }) {
  const html = useMemo(() => ({ __html: alsHtml(anhangText(anhang)) }), [anhang]);
  if (anhang.trim() === '') return null;
  return (
    <details className={stile.anhang}>
      <summary className={stile.zusammenfassung}>Redaktioneller Anhang</summary>
      {/* Bereinigt in `alsHtml` (Allowlist) */}
      <div className={stile.inhalt} dangerouslySetInnerHTML={html} />
    </details>
  );
}
